import * as React from "react";
import {
    USAGE_MAINTENANCE_TOOLBAR,
    SAVE_METHOD_TOOLBAR,
    SAVE_CHANGES_STATE_KEY,
    ALL_ROLES,
    UPDATE_USAGES_ROLE,
    REGROUP_METHOD_TOOLBAR,
    DELETE_USAGE_METHOD_TOOLBAR,
    REGROUP_STATE_KEY,
    DELETE_USAGE_STATE_KEY,
    USAGE_MODAL_HEADER,
    DELETE_USAGE_PROMPT_STATE_KEY,
    MERGE_USAGE_GROUP_STATE_KEY,
    MERGE_USAGE_METHOD_TOOLBAR,
    MERGE_USAGE_PROMPT_STATE_KEY,
    MERGE_USAGE_ONE_USAGE_WARNING_PROMPT_STATE_KEY,
    MERGE_USAGE_MULTIPLE_USAGE_WARNING_PROMPT_STATE_KEY,
    MERGE_USAGE_USAGE_TYPE_MISMATCH_WARNING_PROMPT_STATE_KEY,
    MERGE_USAGE_USAGE_ALLOCATED_WARNING_PROMPT_STATE_KEY
} from "../../../Consts";
import IRepertoireComponentDataItem from "../../../../redux/types/IRepertoireComponentDataItem";
import { clearModalSearchResults, nextWorkflowInSession, startWorkflowSession, updateUsageField } from "../../../../redux/reducers/RepertoireReducer";
import { showYesNoPrompt, hideModal, showModal, showMessage } from "../../../../redux/reducers/ModalReducer";
import { ITabReduxItem } from "../../../../redux/types/ITabReduxItem";
import { IDataActionToolbar } from "../../../../repertoire/types/IDataActionToolbar";
import ToolbarComponent from "../../../components/usageComponents/toolBar/ToolBarComponent";
import { IUsageGroupState } from "../../../../redux/types/IUsageGroupState";
import { IWorkflowSearchResult } from "../../../types/IWorkflowSearchResult";
import { ILookupDictionary } from "../../../../lookup/types/ILookupDictionary";
import { FormatFields } from "../../../../redux/types/FormatFields";
import { IWorkflowParams } from "../../../types/IWorkFlowParams";
import IAppState from "../../../../redux/types/IAppState";
import IShortCutKeys from "../../../../redux/types/IShortCutKeys";
import { connect } from "react-redux";
import { IYesNoPromptViewModalProps } from "../../../components/modalViews/yesNoPromptView/YesNoPromptView";
import { IPopUpInfoProps } from "../../../components/modalViews/popUpInfo/PopUpInfo";
import { get } from "lodash";
import { OPENED_FROM_WORKFLOW_STRING } from "../usageMaintenanceGridsView/UsageMaintenanceGridsView";

export interface IUsageMaintenanceToolbarProps {
    changesMade: boolean;
    hideModal: typeof hideModal;
    showModal: typeof showModal;
    showYesNoPrompt: typeof showYesNoPrompt;
    clearModalSearchResults?: typeof clearModalSearchResults;
    scroll: number;
    toolbarWidth: number;
    toolbarData: IRepertoireComponentDataItem;
    saveResultData: IRepertoireComponentDataItem;
    activeTab: number;
    tabs: ITabReduxItem[];
    saveChanges: () => void;
    resetMessageBanner: () => void;
    isNew?: boolean;
    currentUser?: string;
    usageMaintenanceGeneralDataViewData?: IRepertoireComponentDataItem;
    usageGroup: IUsageGroupState;
    workflowFieldsData?: IRepertoireComponentDataItem;
    isWorkflowSessionStarted?: boolean;
    startWorkflowSession?: typeof startWorkflowSession;
    cancelWorkflowSession?: (activeTab: number) => void;
    nextWorkflowItem?: typeof nextWorkflowInSession;
    skipWorkflowItem?: (
        activeTab: number
        , currentWorkflowIndex: number
        , workflows: IWorkflowSearchResult[]) => void;
    workflowSessionItems?: IWorkflowSearchResult[];
    currentWorkflowIndex?: number;
    isOpenForWorkflowSession?: boolean;
    skipWorkWorkflowItem: (
        activeTab: number
        , currentWorkflowIndex: number
        , workflows: IWorkflowSearchResult[]
        , lookups: ILookupDictionary
        , otherIndicatorsWorkFlagTypes: string[]
        , dataActions: IDataActionToolbar[]
        , workMaintenanceGeneralDataViewData: IRepertoireComponentDataItem
        , formats: FormatFields[]
        , readonlyIndicatorsWorkFlagTypes: string[]) => void;
    formatFields: FormatFields[];
    lookupValues: ILookupDictionary;
    refreshWorkDetails?: () => void;
    saveWorkflow?: (workflowparams: IWorkflowParams) => void;
    completeWorkflowOnSave: (value: boolean) => void;
    roles?: string[];
    updateWorkflowAndEntityStatus?: (workflowparams: IWorkflowParams, approvalStatus: boolean) => void;
    updateClaimWorkflowAndEntityStatus?: (workflowparams: IWorkflowParams, callFrom: string, refreshDetails: () => void) => void;
    shortCutKeys?: IShortCutKeys[];
    getUsageDetails?: (usageID: string, lookupValues?: ILookupDictionary, openEntityForWorflowSession?: boolean,reGroupIds?:Number[]) => void;
    updateUsageField?: typeof updateUsageField;
    updateUsagesAdvanced?: boolean;
    paneIndex?:number;
    saveRegroupedUsageGroup?:(reGroupedUsage:IUsageGroupState,currentPane?:number) =>void;
    distributionStatus?:string;
    enableRegroupAndDeleteUI?:boolean;
    setActivePane: (pane: number) => void;
    showMessage: typeof showMessage;
    mergeUsage: (usageGroupIds: number[], mergeOption: string) => void;
    usageGroupMergeOptions?: string[];
}

export type UsageMaintenanceToolbarKeys = keyof IUsageMaintenanceToolbarProps;

const UsageMaintenanceToolbar = ({
    tabs,
    activeTab,
    toolbarData,
    showYesNoPrompt,
    hideModal,
    showModal,
    resetMessageBanner,
    scroll,
    toolbarWidth,
    saveResultData,
    usageGroup,
    clearModalSearchResults,
    workflowFieldsData,
    isWorkflowSessionStarted,
    startWorkflowSession,
    cancelWorkflowSession,
    nextWorkflowItem,
    skipWorkflowItem,
    workflowSessionItems,
    currentWorkflowIndex,
    isOpenForWorkflowSession,
    skipWorkWorkflowItem,
    formatFields,
    lookupValues,
    refreshWorkDetails,
    saveWorkflow,
    roles,
    updateWorkflowAndEntityStatus,
    updateClaimWorkflowAndEntityStatus,
    completeWorkflowOnSave,
    saveChanges,
    changesMade,
    shortCutKeys,
    getUsageDetails,
    updateUsageField,
    updateUsagesAdvanced,
    paneIndex,
    saveRegroupedUsageGroup,
    distributionStatus,
    enableRegroupAndDeleteUI,
    setActivePane,
    showMessage,
    mergeUsage,
    usageGroupMergeOptions
}) => {

    const saveChangesAction = (usageGroup: IUsageGroupState) => {
        if(paneIndex === 0 && usageGroup.id !== null){
            setActivePane(0);
            saveChanges()
        }else{
            setActivePane(1);
            saveRegroupedUsageGroup(usageGroup,paneIndex)
        }
    }

    const reGroupAction = () => {
        const regroupIds = usageGroup.usages.map((item, index) => Boolean(item.isSelected.value) === true ? index : -1)?.filter(index => index !== -1); 
        getUsageDetails(usageGroup.id, lookupValues, undefined,regroupIds, OPENED_FROM_WORKFLOW_STRING);
        const updatedUsage = usageGroup.usages.map((item, index) => Boolean(item.isSelected.value) === true ? { ...item, isDeleted: true } : item);
        
        updateUsageField(updatedUsage, 'usages');
    }

    const deleteUsage = () => {
        const updatedUsage = (usageGroup.usages ?? []).map(item => ({
            ...item,
            isDeleted: Boolean(item.isSelected?.value)
        }));
        updateUsageField(updatedUsage, 'usages');
        hideModal();
    }

    const deleteAction = () => {
        const message: string = toolbarData.fields.find(f => f.name === DELETE_USAGE_PROMPT_STATE_KEY).data;
        const propsModal: IYesNoPromptViewModalProps = {
                yesCallback: () => { deleteUsage(); }, 
                noCallback: () => { hideModal(); }
        }
        showYesNoPrompt(USAGE_MODAL_HEADER, propsModal, undefined, message);
    }

    const mergeAction = (mergeOption: string) => {
        const message: string = toolbarData.fields.find(f => f.name === MERGE_USAGE_PROMPT_STATE_KEY).data;
        var warning: string = "";

        if (tabs) {
            const usagesToMerge = [...tabs];
            usagesToMerge.splice(activeTab, 1);

            var filteredUsagesToMerge = usagesToMerge.filter(x => x.usageMaintenanceState != undefined
                && x.usageMaintenanceState.usageGroup.mergeThisUsage != undefined
                && x.usageMaintenanceState.usageGroup.mergeThisUsage == true);
                
            var fromUsageGroup = get(filteredUsagesToMerge[0], 'usageMaintenanceState.usageGroup');

            if (filteredUsagesToMerge.length < 1) { 
                warning = toolbarData.fields.find(f => f.name === MERGE_USAGE_ONE_USAGE_WARNING_PROMPT_STATE_KEY).data; 
            }
            else if(filteredUsagesToMerge.length > 1){ 
                warning = toolbarData.fields.find(f => f.name === MERGE_USAGE_MULTIPLE_USAGE_WARNING_PROMPT_STATE_KEY).data; 
            }
            else if(usageGroup.usageType !== fromUsageGroup.usageType) {
                warning = toolbarData.fields.find(f => f.name === MERGE_USAGE_USAGE_TYPE_MISMATCH_WARNING_PROMPT_STATE_KEY).data;
            }
            else if((fromUsageGroup.allocations && fromUsageGroup.allocations.length > 0) || (fromUsageGroup.distributionStatus && fromUsageGroup.distributionStatus === 'Closed')) {
                warning = toolbarData.fields.find(f => f.name === MERGE_USAGE_USAGE_ALLOCATED_WARNING_PROMPT_STATE_KEY).data;
            }
            
            if (warning !== "") {
                const propsModal: IPopUpInfoProps = {
                    textToScreen: warning
                }

                showMessage(propsModal);
            }
            else {
                var result = filteredUsagesToMerge.map(x => ("(" + x.usageMaintenanceState.usageGroup.id + ") " + x.usageMaintenanceState.usageGroup.fullTitle));

                var usageGroupIds = filteredUsagesToMerge.map(x => x.usageMaintenanceState.usageGroup.id);

                const propsModal: IYesNoPromptViewModalProps = {
                    yesCallback: () => { hideModal(); mergeUsage(usageGroupIds, mergeOption); },
                    noCallback: () => { hideModal(); }
                }
                showYesNoPrompt(USAGE_MODAL_HEADER, propsModal, result.toString(), message);
            }
        }
    }
    
    const getUpdateRoleDisabled = (): boolean => {
        if (roles && (roles.includes(UPDATE_USAGES_ROLE) || roles.includes(ALL_ROLES))) {
            return false;
        }
        return true;
    }

    const getDataAction = () => {

        const { fields } = toolbarData;

        const actionList: IDataActionToolbar[] = [];

        const save: IDataActionToolbar = {
            action: saveChangesAction,
            component: USAGE_MAINTENANCE_TOOLBAR,
            method: SAVE_METHOD_TOOLBAR,
            name: fields.find(f => f.name === SAVE_CHANGES_STATE_KEY).data,
            icon: '',
            isReadOnly: getUpdateRoleDisabled()
        };
        actionList.push(save);

        const reGroup: IDataActionToolbar = {
            action: reGroupAction,
            component: USAGE_MAINTENANCE_TOOLBAR,
            method: REGROUP_METHOD_TOOLBAR,
            name: fields.find(f => f.name === REGROUP_STATE_KEY)?.data,
            icon: 'icon ms-Icon ms-Icon--GroupObject',
            isReadOnly: ((usageGroup.allocations && usageGroup.allocations.length > 0) || (distributionStatus && distributionStatus === 'Closed')) ? true: !usageGroup.usages.some(item => Boolean(item.isSelected.value) === true)
        };
        actionList.push(reGroup);

        const deleteUsage: IDataActionToolbar = {
            action: deleteAction,
            component: USAGE_MAINTENANCE_TOOLBAR,
            method: DELETE_USAGE_METHOD_TOOLBAR,
            name: fields.find(f => f.name === DELETE_USAGE_STATE_KEY)?.data,
            icon: 'icon ms-Icon ms-Icon--Delete',
            isReadOnly: ((usageGroup.allocations && usageGroup.allocations.length > 0) || (distributionStatus && distributionStatus === 'Closed')) ? true : !updateUsagesAdvanced && !usageGroup.usages.some(item => Boolean(item.isSelected.value) === true)
        };
        actionList.push(deleteUsage);

        const merge: IDataActionToolbar = {
            action: mergeAction,
            component: USAGE_MAINTENANCE_TOOLBAR,
            method: MERGE_USAGE_METHOD_TOOLBAR,
            name: fields.find(f => f.name === MERGE_USAGE_GROUP_STATE_KEY)?.data,
            icon: 'icon ms-Icon ms-Icon--BranchMerge', 
            isReadOnly: ((usageGroup.allocations && usageGroup.allocations.length > 0) || (distributionStatus && distributionStatus === 'Closed')) ? true : !updateUsagesAdvanced
        };
        actionList.push(merge);

        return actionList;
    }
    React.useEffect(()=>{
        setDataAction(getDataAction());
    },[usageGroup]);
    
    const [dataAction, setDataAction] = React.useState<IDataActionToolbar[]>(getDataAction()); 

        let newChangesMade = !getUpdateRoleDisabled() && changesMade;
        return (
            <>
                <ToolbarComponent
                    scroll={scroll}
                    usageGroup={usageGroup}
                    toolbarWidth={toolbarWidth}
                    saveResultData={saveResultData}
                    resetMessageBanner={resetMessageBanner}
                    changesMade={newChangesMade}
                    activeTab={activeTab}
                    tabs={tabs}
                    dataActionToolbar={enableRegroupAndDeleteUI?dataAction:dataAction?.filter(item=>item.method===SAVE_METHOD_TOOLBAR)}
                    showYesNoPrompt={showYesNoPrompt}
                    hideModal={hideModal}
                    showModal={showModal}
                    clearModalSearchResults={clearModalSearchResults}
                    toolbarData={toolbarData}
                    component={USAGE_MAINTENANCE_TOOLBAR}
                    isNew={tabs[activeTab].usageMaintenanceState.isNew}
                    workflowFieldsData={workflowFieldsData}
                    isWorkflowSessionStarted={isWorkflowSessionStarted}
                    startWorkflowSession={startWorkflowSession}
                    cancelWorkflowSession={cancelWorkflowSession}
                    nextWorkflowItem={nextWorkflowItem}
                    skipWorkflowItem={skipWorkflowItem}
                    workflowSessionItems={workflowSessionItems}
                    currentWorkflowIndex={currentWorkflowIndex}
                    isOpenForWorkflowSession={isOpenForWorkflowSession}
                    skipWorkWorkflowItem={skipWorkWorkflowItem}
                    lookupValues={lookupValues}
                    formatFields={formatFields}
                    refreshWorkDetails={refreshWorkDetails}
                    saveWorkflow={saveWorkflow}
                    roles={roles}
                    updateWorkflowAndEntityStatus={updateWorkflowAndEntityStatus}
                    updateClaimWorkflowAndEntityStatus={updateClaimWorkflowAndEntityStatus}
                    completeWorkflowOnSave={completeWorkflowOnSave}
                    shortCutKeys={shortCutKeys}
                    usageGroupMergeOptions={usageGroupMergeOptions}
                />
            </>
        );
}

export default connect((state: IAppState, props: IUsageMaintenanceToolbarProps) => ({
    shortCutKeys: state.repertoire.shortCutKeys,
}), null)(UsageMaintenanceToolbar);
